import script from "./case_purchase.vue?vue&type=script&setup=true&lang=js"
export * from "./case_purchase.vue?vue&type=script&setup=true&lang=js"

import "./case_purchase.vue?vue&type=style&index=0&id=5a72e410&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a72e410"]])

export default __exports__